import * as React from 'react'

import('./PlayerProfilesStyles.scss')   



const PlayerProfilesPresentation = (props:any) => {

    let homeId = props.teamId.home
    let awayId = props.teamId.away

    return (
        <div className="playerProfiles">
            <div className={`content left`}>
                <img
                    src={`${props.baseUrl}mobile/getPlayerAppearance?clientid=${props.clientId}&playerid=${homeId}&clubid=${homeId}&alignment=left`}/>
            </div>
            <div className={`content center`}>
                {props.children}
            </div>
            <div className={`content right`}>
                <img
                    src={`${props.baseUrl}mobile/getPlayerAppearance?clientid=${props.clientId}&playerid=${awayId}&clubid=${awayId}&alignment=right`}/>
            </div>
        </div>
    )
}

export default PlayerProfilesPresentation